import { render, staticRenderFns } from "./noDataMode.vue?vue&type=template&id=1676a4c3&scoped=true"
import script from "./noDataMode.vue?vue&type=script&lang=js"
export * from "./noDataMode.vue?vue&type=script&lang=js"
import style0 from "./noDataMode.vue?vue&type=style&index=0&id=1676a4c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1676a4c3",
  null
  
)

export default component.exports